import { Mutations } from "vuex";
import { CampaignState, CampaignMutations } from "./types";

export const mutations: Mutations<CampaignState, CampaignMutations> = {
  updateCampaign(state, payload) {
    Object.assign(state, payload);
  },
};
